import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Tooltip } from '@mui/material';

export function ReadOnlyLibraryIndicator() {
  return (
    <Tooltip title="This library is read-only" arrow>
      <span
        tabIndex={0}
        aria-label="This library is read-only"
        onClick={(event) => event.stopPropagation()}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          flexShrink: 0,
          color: 'var(--mui-palette-text-inactive)',
          cursor: 'help',
        }}
      >
        <LockOutlinedIcon fontSize="small" />
      </span>
    </Tooltip>
  );
}
